export default [
    {
        path: 'procedimento',
        component: () => import(
            /* webpackChunkName: 'parametrizacao-procedimento' */
            '@/views/parametrizacao/procedimento/Index'
        ),
        redirect: 'procedimento/index',
        children: [
            {
                name: 'parametrizacao-procedimento-index',
                path: 'index',
                component: () => import(
                    /* webpackChunkName: 'parametrizacao-procedimento' */
                    '@/views/parametrizacao/procedimento/List.vue'
                ),
            },
            {
                name: 'parametrizacao-procedimento-create',
                path: 'create',
                component: () => import(
                    /* webpackChunkName: 'parametrizacao-procedimento' */
                    '@/views/parametrizacao/procedimento/Form.vue'
                ),
            },
            {
                name: 'parametrizacao-procedimento-edit',
                path: 'edit/:id',
                props: route => ({ id: parseInt(route.params.id) }),
                component: () => import(
                    /* webpackChunkName: 'parametrizacao-procedimento' */
                    '@/views/parametrizacao/procedimento/Form.vue'
                ),
            },
        ],
    },
]